import React from 'react';

export default function ModalVisorDocumento({ isOpen, onClose, blobUrl, mimetype, cargando }) {
    if (!isOpen) return null;

    const esImagen = mimetype?.includes('image');
    const esPdf = mimetype?.includes('pdf');

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8 bg-slate-900/80 backdrop-blur-sm animate-fade-in">
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl flex flex-col overflow-hidden h-[90vh]">

                {/* CABECERA */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100 bg-slate-50">
                    <h3 className="text-lg font-black text-slate-800 flex items-center gap-2">
                        <svg className="w-5 h-5 text-clinica-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                        Visor Clínico Seguro
                    </h3>
                    <div className="flex items-center gap-3">
                        {blobUrl && !cargando && (
                            <a href={blobUrl} download="documento_clinico" className="px-4 py-2 text-sm font-bold text-white bg-clinica-primary hover:bg-blue-700 rounded-xl transition-colors flex items-center gap-2 shadow-sm">
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg>
                                Descargar
                            </a>
                        )}
                        <button onClick={onClose} className="p-2 text-slate-400 hover:bg-red-50 hover:text-red-600 rounded-xl transition-colors">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                        </button>
                    </div>
                </div>

                {/* CUERPO DEL VISOR */}
                <div className="flex-1 bg-slate-200/50 p-4 md:p-6 overflow-hidden flex items-center justify-center relative">
                    {cargando ? (
                        <div className="flex flex-col items-center">
                            <svg className="animate-spin h-10 w-10 text-clinica-primary mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                            <p className="text-slate-600 font-bold animate-pulse">Desencriptando archivo en la bóveda...</p>
                        </div>
                    ) : esImagen ? (
                        <img src={blobUrl} alt="Documento Médico" className="max-w-full max-h-full rounded-xl shadow-md border border-slate-200 object-contain bg-white" />
                    ) : esPdf ? (
                        <iframe src={blobUrl} title="Visor PDF" className="w-full h-full rounded-xl shadow-md border border-slate-200 bg-white" />
                    ) : (
                        <div className="text-center bg-white p-12 rounded-2xl shadow-sm border border-slate-200">
                            <p className="text-slate-500 mt-2">Por seguridad, este formato (.doc, .docx) no se visualiza online.<br/>Haz clic en el botón Descargar arriba.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}